export const ALL_TILES = [
  { key: "approve",        title: "Samþykkja nýjan félagsaðila", to: "/members/approve" },
  { key: "interviews",     title: "Skrá viðtöl",                 to: "/interviews/new" },
  { key: "my_interviews",  title: "Mín viðtöl",                  to: "/interviews/mine" },
  { key: "newGroup",       title: "Skrá nýja hópa",              to: "/groups/new" },
  { key: "members",        title: "Yfirlit yfir félagsaðila",    to: "/members" },
  { key: "groups",         title: "Yfirlit yfir hópa",           to: "/groups" },
  { key: "attend",         title: "Skrá mætingu í hóp",          to: "/attendance/group" },
  { key: "attend_house",   title: "Skrá mætingu í hús",          to: "/attendance/house" },
  { key: "summary",        title: "Heildaryfirlit yfir mætingu", to: "/attendance/summary" },
  { key: "interviews_all", title: "Yfirlit yfir viðtöl",         to: "/interviews" },
  { key: "incident",       title: "Skrá atvik",                  to: "/incidents/new" },
  { key: "incidents_all",  title: "Yfirlit yfir atvik",          to: "/incidents" },
  { key: "statistics",     title: "Tölfræði",                    to: "/statistics" },
  { key: "bluebox",        title: "Blái Kassinn",                to: "/bluebox" },
];

export const TILE_KEYS = {
  admin: [
    "approve",
    "interviews",
    "my_interviews",
    "newGroup",
    "members",
    "groups",
    "attend",
    "summary",
    "interviews_all",
    "incident",
    "incidents_all",
    "statistics",
    "bluebox",
  ],

  staff: [
    "interviews",
    "my_interviews",
    "members",
    "groups",
    "attend",
    "incident",
    "bluebox",
  ],
  
  peer_support: [
    "interviews",
    "my_interviews",
    "attend",
  ],

  group_leader: ["attend"],

  house_only: ["attend_house"],

  
};

export function tilesForRole(role) {
  const keys = TILE_KEYS[role] || [];
  const map = Object.fromEntries(ALL_TILES.map((t) => [t.key, t]));
  return keys.map((k) => map[k]).filter(Boolean);
}